import RecurringOrderSuggestionsDiscardReasonsModal from 'components/RecurringOrderSuggestionsDiscardReasonsModal/styled';

export default RecurringOrderSuggestionsDiscardReasonsModal;
